<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
  >
    <template #fields="slotProps">
      <div v-if="updateSlotProps(slotProps)" style="display: none"></div>
      <div class="flex flex-col">
        <label for="segmentMame" class="small-label">Название сегмента</label>
        <InputText
          id="segmentMame"
          placeholder="Введите название"
          v-model="slotProps.filter.name"
          aria-describedby="username-help"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="date" class="small-label">Дата создания</label>
        <Calendar
          id="date"
          panelClass="not-extended"
          placeholder="Выберите значение"
          v-model="slotProps.filter.date"
          aria-describedby="date-help"
          showIcon
          iconDisplay="input"
          inputId="icondisplay"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Статус сегмента</label>
        <MultiSelect
          v-model="slotProps.filter.state"
          optionValue="id"
          :options="segmentsDictionariesStore.statesAllowed"
          optionLabel="display_name"
          placeholder="Выберите значение"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="type" class="small-label">Тип сегмента</label>
        <div
          v-for="sType in segmentsDictionariesStore.types"
          :key="sType.id"
          class="flex type-checkbox"
        >
          <Checkbox
            v-model="slotProps.filter.type"
            :inputId="`type-${sType.id}`"
            :value="sType.id"
          />
          <label :for="`type-${sType.id}`" class="m-l-10">
            {{ sType.display_name }}
          </label>
        </div>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Категория</label>
        <CategoryTreeInput
          :modelValue="slotProps.filter.category"
          ref="childCategoryTree"
          :isSegmentSetted="false"
          @update:modelValue="
          ($event: any) => (slotProps.filter.category = $event)
        "
        ></CategoryTreeInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Бренд</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="brand"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.brand"
          @update:modelValue="($event) => (slotProps.filter.brand = $event)"
        ></CatalogDataBaseInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Магазин</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="segment_shop"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.shop"
          @update:modelValue="($event) => (slotProps.filter.shop = $event)"
        ></CatalogDataBaseInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Автор</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="user"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.user"
          @update:modelValue="($event) => (slotProps.filter.user = $event)"
        ></CatalogDataBaseInput>
      </div>
      <div class="flex flex-col m-t-8">
        <label class="small-label">Фильтр по полу</label>
        <div class="gender-filter-section">
          <div class="female-male-container">
            <div class="gender-option">
              <Checkbox v-model="maleCheckbox" binary input-id="maleCheckbox" />
              <label for="maleCheckbox" class="gender-checkbox-label"
                >Мужчины</label
              >
            </div>
            <div class="gender-option">
              <Checkbox
                v-model="femaleCheckbox"
                binary
                input-id="femaleCheckbox"
              />
              <label for="femaleCheckbox" class="gender-checkbox-label"
                >Женщины</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col m-t-8">
        <label class="small-label">Фильтр по возрасту</label>
        <div class="gender-filter-section">
          <div class="age-container">
            <div
              v-for="age in ageOptions"
              :key="age.value"
              class="gender-option"
            >
              <Checkbox
                :model-value="
                  slotPropsRef?.filter?.age?.includes(age.value) || false
                "
                @update:model-value="(value: boolean) => {
                  if (slotPropsRef?.filter) {
                    slotPropsRef.filter.age = toggleAgeValue(
                      slotPropsRef.filter.age || [],
                      age.value
                    );
                  }
                }"
                binary
                :input-id="`ageCheckbox${age.value}`"
              />
              <label
                :for="`ageCheckbox${age.value}`"
                class="gender-checkbox-label"
                >{{ age.label }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";
import MultiSelect from "primevue/multiselect";
import Checkbox from "primevue/checkbox";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import CategoryTreeInput from "@/entities/segments/forms/CategoryTreeInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";

import { useSegmentsDictionariesStore } from "@/store/dictionaries/segments";
import {
  GENDER_VALUES,
  toggleGenderValue,
  toggleAgeValue,
} from "@/services/segments/utils";
import { useAgesStore } from "@/store/catalog_data/ages";
import { computed, ref, onMounted } from "vue";

const props = defineProps<{
  isFilterEnabled: boolean;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);
const segmentsDictionariesStore = useSegmentsDictionariesStore();
const agesStore = useAgesStore();

const initialFilter = {
  name: "",
  date: null,
  state: [] as number[],
  type: [] as number[],
  user: [] as number[],
  brand: [] as string[],
  category: [] as any[],
  shop: [] as number[],
  gender: [] as number[],
  age: [] as number[],
};

// Ref для хранения ссылки на slotProps
const slotPropsRef = ref<any>(null);

// Computed свойства для чекбоксов gender
const maleCheckbox = computed({
  get: () => {
    return (
      slotPropsRef.value?.filter?.gender?.includes(GENDER_VALUES.MALE) || false
    );
  },
  set: (value: boolean) => {
    if (slotPropsRef.value?.filter) {
      slotPropsRef.value.filter.gender = toggleGenderValue(
        slotPropsRef.value.filter.gender || [],
        GENDER_VALUES.MALE
      );
    }
  },
});

const femaleCheckbox = computed({
  get: () => {
    return (
      slotPropsRef.value?.filter?.gender?.includes(GENDER_VALUES.FEMALE) ||
      false
    );
  },
  set: (value: boolean) => {
    if (slotPropsRef.value?.filter) {
      slotPropsRef.value.filter.gender = toggleGenderValue(
        slotPropsRef.value.filter.gender || [],
        GENDER_VALUES.FEMALE
      );
    }
  },
});

// Опции для возраста из store
const ageOptions = computed(() => {
  return agesStore.itemList.map((age) => ({
    value: age.id,
    label: age.type,
  }));
});

const updateSlotProps = (slotProps: any) => {
  slotPropsRef.value = slotProps;
  return true;
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

onMounted(async () => {
  // Загружаем справочник возрастов
  if (agesStore.itemList.length === 0) {
    await agesStore.getItems("", [], true, false, 0, 50, true);
  }
});
</script>

<style lang="scss" scoped>
.gender-filter-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #cbd5e1;
  margin-top: 4px;
}

.gender-filter-label {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.4rem;
  margin-bottom: 12px;
  display: block;
}

.female-male-container {
  display: flex;
  gap: 24px;
  align-items: center;
}

.gender-option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(108, 117, 125, 0.1);
  }
}

.gender-checkbox-label {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin-left: 8px;
  cursor: pointer;
  user-select: none;
}

.age-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  align-items: flex-start;
}
</style>
